import { defineMessages } from 'react-intl';

const translations = {
  confirmPackingActionDialog: {
    title: {
      id: 'confirmPackingActionDialog.title',
      defaultMessage: 'Park or ship parcels?',
      description: 'Title of the confirm packing action dialog',
    },
    description: {
      id: 'confirmPackingActionDialog.description',
      defaultMessage:
        "This shipment doesn't have to be shipped directly. Would you like to ship it anyways, or would you like to park the parcels?",
      description: 'Description of the confirm packing action dialog',
    },
    buttons: {
      park: {
        id: 'actions.park',
        defaultMessage: 'Park',
        description: 'Label of the park button in the confirm packing action dialog',
      },
      ship: {
        id: 'actions.ship',
        defaultMessage: 'Ship',
        description: 'Label of the ship button in the confirm packing action dialog',
      },
    },
  },
  feedback: {
    parcelNotCreated: {
      id: 'packing.feedback.parcelNotCreated',
      defaultMessage: 'Parcel could not be created',
      description: 'Error message of the create parcel action',
    },
    parcelDeleted: {
      id: 'packing.feedback.parcelDeleted',
      defaultMessage: 'Parcel deleted',
      description: 'Success message of the delete parcel action',
    },
    parcelNotDeleted: {
      id: 'packing.feedback.parcelNotDeleted',
      defaultMessage: 'Parcel could not be deleted',
      description: 'Error message of the delete parcel action',
    },
  },
};

export default defineMessages(translations);
